import React from 'react';
import { Box, Typography, CircularProgress } from '@mui/material';
import { useAuth } from 'oidc-react';
import { useApiClient } from '@/hooks/useApiClient';
import TagVocabularyManager from '@/components/admin/TagVocabularyManager';

/** The admin's tag vocabulary (AG-249) — the page behind "Taggvokabulär" in the admin nav. */
const AdminTagsPage: React.FC = () => {
  useApiClient(); // Inject current OIDC token into API client
  const { userData } = useAuth(); // Get OIDC authentication state

  // Wait for authentication before rendering content
  if (!userData?.access_token) {
    return (
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          minHeight: "50vh"
        }}>
        <CircularProgress />
      </Box>
    );
  }

  return (
    <Box sx={{ p: 3 }}>
      <Typography variant="h4" component="h1" gutterBottom>
        Taggvokabulär
      </Typography>
      <Typography
        variant="body1"
        sx={{
          color: "text.secondary",
          mb: 2
        }}>
        Hantera taggvokabulären. Ett dokument bär en eller flera taggrupper och uppfyller ett krav när
        någon grupp täcker kravets taggar — färre taggar på kravet betyder ett bredare krav.
        Sluggen är identiteten och kan inte ändras; byt visningsnamn i stället.
      </Typography>

      <TagVocabularyManager />
    </Box>
  );
};

export default AdminTagsPage;